import React from "react";
import upiQr from "../../image/upi-qr-roshni.jpeg";
import "./ManualUpi.scss";

const UpiPaymentBox = ({ grandTotal, bill, onPaymentSubmit }) => {
  return (
    <div className="section-card upi-box">
      <h3 className="upi-title">Pay using UPI</h3>

      {/* QR IMAGE */}
      <img
        src={upiQr} // later from API
        alt="UPI QR"
        className="upi-qr"
      />

      {/* UPI DETAILS */}
      <div className="upi-details">
        <div>
          <b>UPI ID:</b> 7581883535@ptsbi
        </div>
        <div>
          <b>Amount:</b> ₹{grandTotal}
        </div>
        <div>
          <b>Table:</b> {bill?.[0]?.tableNumber || "—"}
        </div>
      </div>

      <button className="pay-btn secondary" onClick={onPaymentSubmit}>
        I’ve Paid
      </button>

      <p className="upi-note">Payment will be confirmed by restaurant staff</p>
    </div>
  );
};

export default UpiPaymentBox;
